import { Constant } from 'types/api/api.type';
import { CustomerData, CustomerDetailsDto } from 'types/api/customer.type';
import { NotificationCustomer } from 'types/api/notification.type';

const emptyStructure: Constant = { key: '', value: '' };

const emptyNotifications: NotificationCustomer = {
  customerId: '',
  code: null,
  count: 0,
  status: '',
};

export function mapCustomerDetailsToCustomerData(d: CustomerDetailsDto): CustomerData {
  const pt = d.paymentType;
  const paymentLabel =
    pt.descriptionIt && pt.descriptionEn
      ? `${pt.descriptionIt} / ${pt.descriptionEn}`
      : pt.descriptionIt || pt.descriptionEn || pt.code || '';

  return {
    id: String(d.customerId),
    customerId: String(d.customerId),
    code: d.customerCode,
    zone: d.commercialZoneCode,
    companyName: d.displayName,
    address: d.billingAddress?.addressLine ?? '',
    postCode: d.billingAddress?.zipCode ?? '',
    city: d.billingAddress?.city ?? '',
    province: d.billingAddress?.subdivisionName ?? '',
    country: d.billingAddress?.countryName ?? '',
    vatNumber: '',
    fiscalCode: '',
    contactPerson: d.contactPerson ?? '',
    phoneNumber: d.telephone ?? '',
    email: d.email ?? '',
    bankName: paymentLabel,
    iban: '',
    abi: '',
    cab: '',
    bicSwift: '',
    emailPec: '',
    emailAccounting: '',
    emailLogistic: '',
    sdi: '',
    webAddress: '',
    structure: emptyStructure,
    note: '',
    structureTypeName: '',
    structureTypeDesc: '',
    wholesaleFurniture: '',
    continent: '',
    timestamp: '',
    controlCode: '',
    status: 'NEW',
    vatCce: '',
    abandoned: '',
    notifications: emptyNotifications,
    name: d.displayName,
    isReactivated: false,
    takeoverCode: { key: '', value: '' },
  };
}
